export default "__VITE_ASSET__DlO18E5p__"